import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
import { UnifiedRestServiceBase } from "./ExpAPIVUnified.resource.js";
import { buildOdataQuery } from "@ane/core/lib/utils/ODataUtils";
import { noCache } from "../../services/middlewares/NoCacheMiddleware.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let ExperimentUnifiedResource = class extends UnifiedRestServiceBase {
  constructor() {
    super("experiments");
  }
  startAsync(workspaceId, id) {
    return this._post(
      null,
      buildOdataQuery(void 0, {
        baseUrl: `${this.getResourceUrl(workspaceId, id)}:start`,
        additionalQueryParams: this.getDefaultQueryParams()
      })
    );
  }
  stopAsync(workspaceId, id) {
    return this._post(
      null,
      buildOdataQuery(void 0, {
        baseUrl: `${this.getResourceUrl(workspaceId, id)}:stop`,
        additionalQueryParams: this.getDefaultQueryParams()
      })
    );
  }
  advanceAsync(workspaceId, id) {
    return this._post(
      null,
      buildOdataQuery(void 0, {
        baseUrl: `${this.getResourceUrl(workspaceId, id)}:advance`,
        additionalQueryParams: this.getDefaultQueryParams()
      })
    );
  }
  getOperationsAsync(workspaceId, id) {
    return this._get(
      buildOdataQuery(void 0, {
        baseUrl: `${this.getResourceUrl(workspaceId, id)}/operations`,
        additionalQueryParams: this.getDefaultQueryParams()
      })
    );
  }
};
ExperimentUnifiedResource = __decorateClass([
  noCache(),
  WPSProxyConverter()
], ExperimentUnifiedResource);
const ExperimentUnifiedResourceInstance = new ExperimentUnifiedResource();
export {
  ExperimentUnifiedResource,
  ExperimentUnifiedResourceInstance as default
};
//# sourceMappingURL=Experiment.unified.resource.js.map
